import workspaceQuery from 'graphql/queries/purchases/PurchaseRequirementWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/purchases/PurchaseRequirementQuery.graphql';
import mutationQuery from 'graphql/mutations/purchases/PurchaseRequirementMutation.graphql';
import fragment from 'graphql/fragments/purchases/PurchaseRequirementFragment.graphql';

import { workspace } from 'actions/purchasing/PurchaseRequirementWorkspaceAction';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseRequirement: EntityType = {
  type: 'PurchaseRequirement',
  title: 'Shortages',
  formUrl: '/Purchasing/Shortages/Details/',
  formTitle: 'Shortages',
  workspaceUrl: '/Purchasing/Shortages/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'SHORTAGES',
  actions: workspace,
};

export default PurchaseRequirement;
